import React from "react";
import { useTranslation } from "react-i18next";

const ShutdownAddNav: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      data-testid="shutdown-add-nav"
      className="p-[1rem] md:p-[2rem] flex flex-col w-auto max-w-[90rem] mx-auto"
    >
      <nav className="mb-2">
        <div className="flex items-center space-x-4">
          <a
            href="/shutdown_add"
            className="inline-flex items-center px-4 py-2 rounded-lg bg-blue-100 hover:bg-blue-200 text-blue-800 font-medium transition-colors duration-200"
          >
            {t("navigation.punch_card", "Punch card")}
          </a>
          <a
            href="/shutdown_add_xlsx"
            className="inline-flex items-center px-4 py-2 rounded-lg bg-green-100 hover:bg-green-200 text-green-800 font-medium transition-colors duration-200"
          >
            {"Upload"}
          </a>
          <a
            href="/shutdown_download_xlsx"
            className="inline-flex items-center px-4 py-2 rounded-lg bg-green-100 hover:bg-green-200 text-green-800 font-medium transition-colors duration-200"
          >
            {"Download"}
          </a>
          <a
            href="/shutdown_publish"
            className="inline-flex items-center px-4 py-2 rounded-lg bg-purple-100 hover:bg-purple-200 text-purple-800 font-medium transition-colors duration-200"
          >
            {t("navigation.publish", "Publish")}
          </a>
          <a
            href="/white_list_checker"
            className="inline-flex items-center px-4 py-2 rounded-lg bg-yellow-100 hover:bg-yellow-200 text-yellow-800 font-medium transition-colors duration-200"
          >
            {t("navigation.white_list_checker", "Wired White List")}
          </a>
          <a
            href="/white_list_checker_upload_tokens"
            className="inline-flex items-center px-4 py-2 rounded-lg bg-orange-100 hover:bg-orange-200 text-orange-800 font-medium transition-colors duration-200"
          >
            {"Upload tokens"}
          </a>
        </div>
      </nav>
    </div>
  );
};

export default ShutdownAddNav;
